import { render, staticRenderFns } from "./ArchivedCustomers.vue?vue&type=template&id=a89c2684&scoped=true"
import script from "./ArchivedCustomers.vue?vue&type=script&lang=js"
export * from "./ArchivedCustomers.vue?vue&type=script&lang=js"
import style0 from "./ArchivedCustomers.vue?vue&type=style&index=0&id=a89c2684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89c2684",
  null
  
)

export default component.exports